import { SET_MAP_DATA, SET_MAP_DISPLAY, SET_MAP_ZOOM } from 'aria-viewer/map/mapActions'
import { Map } from 'immutable'

const INITIAL_STATE = Map({
    mapData: {
        trails: [],
    },
    mapDisplayMode: null,
    mapZoomBounds: Map({
        min: 9,
        max: 11,
        level: 10,
    }),
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_MAP_DATA:
            return state.set('mapData', action.data)
        case SET_MAP_DISPLAY:
            return state.set('mapDisplayMode', action.mode)
        case SET_MAP_ZOOM:
            return state.set(
                'mapZoomBounds',
                state.get('mapZoomBounds').merge(
                    Object.keys(action.zoom).reduce((props, key) => {
                        return typeof action.zoom[key] == 'undefined' ? props : { ...props, [key]: action.zoom[key] }
                    }, {})
                )
            )
        default:
            return state
    }
}
